import React from 'react';
import { Route, Switch } from 'react-router';
import PropTypes from 'prop-types';

import Sidebar from './widgets/Sidebar';
import WidgetCategoryContainer from './widgets/containers/WidgetCategoryContainer';
import WidgetReferenceContainer from './widgets/containers/WidgetReferenceContainer';
import Footer from './shared/Footer';
import ScrollToTop from './shared/ScrollToTop';
import HtmlPage from './widgets/HtmlPage';
import DropdownContainer from './widgets/containers/DropdownContainer';

// Presentational Component
const Widgets = ({ categories, widgets, widget }) => {
	return (
		<div className="page">
			<Sidebar
				categories={categories}
				widgets={widgets}
			/>
			<main className="content with-sidebar" id="content">
				<div className="section">
					<div className='responsive-small'>
						<DropdownContainer />
					</div>
					<ScrollToTop scrollElId="content">
						<Switch>
							<Route exact path="/widgets" render={() => <HtmlPage page="Intro" />} ></Route>
							<Route exact path="/widgets/intro" render={() => <HtmlPage page="Intro" />} ></Route>
							<Route exact path="/widgets/how" render={() => <HtmlPage page="How" />} ></Route>
							<Route exact path="/widgets/customize" render={() => <HtmlPage page="Customize" />} ></Route>
							<Route exact path="/widgets/style" render={() => <HtmlPage page="Style" />} ></Route>
							<Route exact path="/widgets/:category" component={WidgetCategoryContainer} ></Route>
							<Route path="/widgets/:category/:widget" component={WidgetReferenceContainer} ></Route>
						</Switch>
					</ScrollToTop>
				</div>
				<Footer />
			</main>
		</div>
	);
};

Widgets.propTypes = {
	categories: PropTypes.object.isRequired,
	widgets: PropTypes.object.isRequired,
	widget: PropTypes.string
};

export default Widgets;


// WEBPACK FOOTER //
// ./src/components/Widgets.js